const DataNilaiKognitif = [
  {
    id : "1",
    jenisTest : "Pretest",
    nilaiTest : 50
  },
  {
    id : "2",
    jenisTest : "Weekly Test 1",
    nilaiTest : 78
  },
  {
    id : "3",
    jenisTest : "Weekly Test 2",
    nilaiTest : 83
  },
  {
    id : "4",
    jenisTest : "Weekly Test 3",
    nilaiTest : 84
  },
  {
    id : "5",
    jenisTest : "Weekly Test 4",
    nilaiTest : 86
  },
  {
    id : "6",
    jenisTest : "Posttest",
    nilaiTest : 87
  },
  {
    id : "7",
    jenisTest : "Aplikasi Lapangan",
    nilaiTest : 89
  },
  {
    id : "8",
    jenisTest : "Pengukuhan",
    nilaiTest : 87
  },
]

export default DataNilaiKognitif